<template>
  <section>
    <div class="container">
      <div class="row justify-content-center justify-content-md-between">
        <div class="col-auto px-0">
          <mdb-btn flat dark-waves icon="arrow-left" type="button" title="Regresar" @click="$router.go(-1)">
            Regresar
          </mdb-btn>
        </div>
      </div>
      <div class="encabezado-detalles">
        <header class="h4-responsive text-center pt-3">Reporte</header>
        <div class="row mx-0 mt-2">
          <div class="col-12 col-md-4">
            <span class="small-block font-titulo">Nombre del reporte</span>
            <p>
              Clientes por vendedor
            </p>
          </div>
          <div class="col-12">
            <span class="small-block font-titulo">Descripción</span>
            <p class="mb-1">
              Distribución de clientes activos por vendedor según el tipo de cliente durante el período seleccionado.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <mdb-input v-model="fechaMes" type="month" label="Mes" class="my-2" outline />
        </div>
      </div>
    </div>
    <div v-if="cargando" class="mensaje-no-items py-3">
      <LoaderKel />
      <p class="texto mt-2">
        Cargando
      </p>
    </div>
    <!-- Mensaje cuando el vendedor seleccionado no tiene pedido -->
    <div v-else-if="!data.length" class="mensaje-no-items pb-3">
      <font-awesome-icon icon="clipboard-list" size="5x" class="icono" />
      <p class="texto">No hay reportes según los parámetros seleccionados</p>
    </div>
    <div class="container" v-else>
      <div class="table-container">
        <div class="table-wrapper">
          <table>
            <thead>
              <th>
                <div class="ancho-3">
                  Vendedor
                </div>
              </th>
              <th v-for="tipo in tiposCliente" :key="tipo.id_tcl">
                <div>
                  {{ tipo.nom_tcl }}
                </div>
              </th>
              <th>
                <div>
                  Total
                </div>
              </th>
            </thead>
            <tbody>
              <tr v-for="(p, i) in data" :key="i" :class="{ 'fila-totales': p.vendedor === 'TOTALES' }">
                <td data-columna="Vendedor">
                  <div>
                    <p class="">
                      {{ p.vendedor }}
                    </p>
                  </div>
                </td>
                <td v-for="tipo in tiposCliente" :key="tipo.id_tcl" :data-columna="tipo.nom_tcl">
                  <div class="">
                    <p>{{ p[tipo.id_tcl] || 0 }}</p>
                  </div>
                </td>
                <td data-columna="Total">
                  <p>
                    {{ p.total }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>

    <AlertaMensaje :alerta-mensaje="alertaMensaje" @cerrar="alertaMensaje.contenido = ''" />
  </section>
</template>

<script>
import { mdbInput, mdbBtn } from 'mdbvue'
// import FiltrosTipo1 from '@/components/FiltrosTipo1.vue'
import AlertaMensaje from '@/components/AlertaMensaje.vue'
import LoaderKel from '@/components/LoaderKel.vue'
import { apiPost } from '@/funciones/api.js'
import { convertirNumeroAFixed } from '@/funciones/funciones.js'
export default {
  name: 'Actividades',
  components: {
    mdbInput,
    mdbBtn,
    // FiltrosTipo1,
    AlertaMensaje,
    LoaderKel
  },
  data () {
    return {
      cargando: false,
      fechaMes: (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString(),
      alertaMensaje: { contenido: '' },
      data: [],
      tiposCliente: []
    }
  },
  mounted () {
    this.obtenerTiposCliente()
    this.actualizar()
  },
  watch: {
    fechaMes () {
      this.actualizar()
    }
  },
  methods: {
    obtenerTiposCliente () {
      apiPost({ s: 'tipcliM' }, '')
        .then((res) => {
          if (res.data) {
            this.tiposCliente = res.data.tcl
          }
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los tipos de cliente',
            tipo: 'error'
          }
        })
    },
    getIdColumnaPorTipo (tipoCliente) {
      const tipo = this.tiposCliente.find(t =>
        t.nom_tcl && t.nom_tcl.toLowerCase().trim() === tipoCliente.trim()
      )

      if (tipo) {
        return tipo.id_tcl
      }

      return null
    },
    restablecerFiltros () {
      this.restablecer = true
      this.fechaMes = (new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).substr(-2)).toString()
      this.actualizar()
    },
    actualizar () {
      this.cargando = true
      const data = this.fechaMes ? 'ver_ano=' + this.fechaMes.substring(0, 4) + '&ver_mes=' + this.fechaMes.substring(5, 7) : ''
      apiPost({ s: 'tiposClientesActivos' }, data)
        .then((res) => {
          this.cargando = false
          if (res.data) {
            this.procesarDatos(res.data.clientes_activos)
          }
        }).catch(() => {
          this.alertaMensaje = {
            contenido: 'Ocurrió un error obteniendo los datos',
            tipo: 'error'
          }
        })
    },
    procesarDatos (datosBackend) {
      const datosProcesados = {}

      datosBackend.forEach(item => {
        if (!datosProcesados[item.id_vendedor]) {
          datosProcesados[item.id_vendedor] = {
            vendedor: item.nombre_vendedor,
            total: 0
          }

          this.tiposCliente.forEach(tipo => {
            datosProcesados[item.id_vendedor][tipo.id_tcl] = 0
          })
        }

        if (item.tipos_cliente && Array.isArray(item.tipos_cliente)) {
          item.tipos_cliente.forEach(tipo => {
            const tipoCliente = tipo.tipo_cliente.trim().toLowerCase()
            const cantidad = tipo.total_clientes_activos || 0

            const idColumna = this.getIdColumnaPorTipo(tipoCliente)
            if (idColumna) {
              datosProcesados[item.id_vendedor][idColumna] += cantidad
              datosProcesados[item.id_vendedor].total += cantidad
            }
          })
        }
      })

      const totales = {
        vendedor: 'TOTALES',
        total: 0
      }

      this.tiposCliente.forEach(tipo => {
        totales[tipo.id_tcl] = 0
      })

      Object.values(datosProcesados).forEach(item => {
        totales.total += item.total

        this.tiposCliente.forEach(tipo => {
          if (Object.prototype.hasOwnProperty.call(item, tipo.id_tcl)) {
            totales[tipo.id_tcl] += item[tipo.id_tcl] || 0
          }
        })
      })

      const datosConTotales = Object.values(datosProcesados)
      datosConTotales.push(totales)

      this.data = datosConTotales.sort((a, b) => {
        if (a.vendedor === 'TOTALES') return 1
        if (b.vendedor === 'TOTALES') return -1
        return a.vendedor.localeCompare(b.vendedor)
      })
    },
    convertirValorAFixed (numero) {
      return convertirNumeroAFixed(numero)
    },
    mesDelAño () {
      const meses = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      return meses[parseInt(this.fechaMes.split('-')[1], 10) - 1]
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 80dvw;
  margin: 0 auto;
  padding: 20px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

thead {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px #dddddd solid;
  background-color: #fafafa;
}

th {
  font-weight: 600;
  text-align: left;
  padding: .6rem .4rem .6rem .4rem;
  white-space: nowrap;
  font-size: .7rem;
  text-transform: uppercase;
}

th:last-child {
  border-right: none;
}

td {
  padding: .3rem;
  padding-bottom: 0;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
  font-size: .75rem;
}

tr:hover td {
  background-color: #f9f9f9;
}

// tr:nth-child(even) {
//   background-color: #f8f9fa;
// }

tr:nth-child(even):hover td {
  background-color: #f1f3f4;
}

.table-container {
  border: 1px solid #e7e6e6;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 30px;
}

.table-wrapper {
  overflow: auto;
  max-height: 80dvh;
}

.ancho-1 {
  width: 300px;
}

.ancho-2 {
  width: 200px;
}

.ancho-3 {
  width: 100px;
}

.table.actividades {
  // Define los breakpoints para el responsive de ul.table
  @include ul-table-responsive-at ("576px");
}

.tabla-container {
  overflow: auto;
}

.contenedor-tabla {
  max-width: 80dvw;
}

@media (max-width: 1020px) {
  .container {
    width: 100dvw;
    padding: 0px;
  }

  .table-wrapper {
    width: 100dvw;
  }
}

@media (max-width: 576px) {
  .table-wrapper {
    max-height: none;
    overflow-x: hidden;
  }

  table {
    width: 100%;
  }

  thead {
    display: none;
  }

  tr {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid black;
    width: 90%
  }

  td {
    display: flex;
    flex-wrap: nowrap;
    padding-top: .5rem !important;
    padding-bottom: 0rem !important;
    height: auto !important;
    border: none;
    width: 90% !important;
    min-width: 0;
  }

  td::before {
    content: attr(data-columna) "                          " attr(second-data-columna);
    white-space: pre-wrap;
    font-weight: 500;
    margin-right: .25rem;
    min-width: 105px;
    width: 105px !important;
    flex-shrink: 0;
  }

  td>div {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  td>div>p,
  td>div>span {
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
  }
}

.fila-totales {
  background-color: #f0f4f8;
  border-top: 2px solid #dee2e6;
  font-weight: 600;
}

.fila-totales td {
  border-bottom: none;
  background-color: #f0f4f8;
}

.fila-totales p {
  font-weight: bold !important;
}
</style>
